import React from "react";
import DashboardTile from "../DashboardTile";
import "./DashBoardSummaryTile.scss";
import DashboardSummaryStock from "./DashboardSummaryStock";
import DashboardSummaryAdmission from "./DashboardSummaryAdmission";
import DashboardSummaryContract from "./DashboardSummaryContract";
import DashboardSummaryDisease from "./DashboardSummaryDisease";
import DashboardSummarySensor from "./DashboardSummarySensor";
import DashboardSummaryDataset from "./DashboardSummaryDataset";
import DashboardSummaryBalance from "./DashboardSummaryBalance";

// ALGEMEEN
// Klik op titels gaat naar algemene pagina
// Klik op specifieke elementen in widget gaat naar gefilterde view

const DashboardSummaryTile = () => {
  return (
    <DashboardTile padding="">
      <div className="p-3 pt-0">
        <div className="row">
          <DashboardSummaryStock />
          <DashboardSummaryAdmission />
          <DashboardSummaryContract />
          <DashboardSummaryDisease />
          <DashboardSummarySensor />
          <DashboardSummaryDataset />
          <DashboardSummaryBalance />
        </div>
      </div>
    </DashboardTile>
  );
};

export default DashboardSummaryTile;
